import type { ReactNode } from 'react';

import { GradientBackground } from '@/components/ui/gradient-background';

interface SignupSplitLayoutProps {
  children: ReactNode;
  socialProof?: ReactNode;
}

export function SignupSplitLayout({ children, socialProof }: SignupSplitLayoutProps) {
  return (
    <GradientBackground className="min-h-[calc(100dvh-3rem)]">
      <div className="mx-auto grid max-w-6xl gap-10 px-4 pb-12 pt-8 sm:px-6 sm:pt-10 lg:grid-cols-2 lg:items-start lg:gap-12 lg:px-8 lg:pb-16 lg:pt-12">
        <div className="flex w-full flex-col items-start lg:order-1">
          <div className="w-full max-w-md">{children}</div>
        </div>

        {socialProof ? (
          <div className="hidden lg:order-2 lg:flex lg:justify-end lg:self-center">
            {socialProof}
          </div>
        ) : null}
      </div>
    </GradientBackground>
  );
}
